document.addEventListener('DOMContentLoaded', () => {

  if (!window.location.pathname.includes('/products/')) return;

  const STORAGE_KEY = 'izyrent_travellers'

  // ---------- SAVE ----------
  function saveData() {
    const data = {}

    const travellerBlocks = document.querySelectorAll('select')

    travellerBlocks.forEach(select => {
      const label = select.closest('div')?.innerText?.toLowerCase() || ''

      // tunnista traveller numero tekstistä
      const match = label.match(/traveller\s*(\d+)/)
      if (!match) return

      const traveller = match[1]

      if (!data[traveller]) data[traveller] = {}

      if (label.includes('cloth')) {
        data[traveller].clothing = select.value
      }

      if (label.includes('boot') || label.includes('shoe')) {
        data[traveller].boots = select.value
      }
    })

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  }

  // ---------- RESTORE ----------
  function restoreData() {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) return

  const data = JSON.parse(raw)

  document.querySelectorAll('select').forEach(select => {
    const label = select.closest('div')?.innerText?.toLowerCase() || ''
    const match = label.match(/traveller\s*(\d+)/)
    if (!match) return

    const traveller = match[1]
    const tData = data[traveller]
    if (!tData) return

    let newValue = null

    if (label.includes('cloth') && tData.clothing) {
      newValue = tData.clothing
    }

    if ((label.includes('boot') || label.includes('shoe')) && tData.boots) {
      newValue = tData.boots
    }

    if (newValue && select.value !== newValue) {
      select.value = newValue

      // 🔥 CRITICAL PART
      select.dispatchEvent(new Event('input', { bubbles: true }))
      select.dispatchEvent(new Event('change', { bubbles: true }))
      select.dispatchEvent(new Event('blur', { bubbles: true }))
    }
  })
}

  // ---------- EVENTS ----------
  document.addEventListener('change', (e) => {
    if (e.target.tagName === 'SELECT') {
      saveData()
    }
  })

  // ---------- WATCH DOM (minimal, ei looppeja) ----------
  const observer = new MutationObserver(() => {
    restoreData()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })

})